<template>
  <my-profile-menu-layout>
    <trusted-devices></trusted-devices>
  </my-profile-menu-layout>
</template>

<script>
import MyProfileMenuLayout from "@/components/layout/MyProfileMenuLayout";
import TrustedDevices from "@/components/myprofile/TrustedDevices";
import CurrentUserMixin from "@/mixins/CurrentUserMixin";

export default {
  name: "ProfileTrustedDevices",
  components: { MyProfileMenuLayout, TrustedDevices },
  mixins: [CurrentUserMixin],
  data() {
    return {
      loading: false,
    }
  },
  mounted() {
    // Profile pages don't need a project context
  },
}
</script>

<style scoped>

</style> 